import React, { useEffect, useState } from "react";
import Slide from "@material-ui/core/Slide";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as GenSettingActions from "../../../store/actions/GenSetting";
import { withTheme } from "react-jsonschema-form";
import { Theme as MuiTheme } from "rjsf-material-ui";
import * as LevelActions from "../../../store/actions/Level";
import { isEmpty } from "../../../utils/index";
import AnimatedDialog from "../../Common/AnimatedDialog";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Form = withTheme(MuiTheme);

const useStyles = makeStyles((theme) => ({
  errorSpacing: {
    marginTop: "1.25rem",
  },
}));

const formschema = {
  title: "Order Details",
  type: "object",
  required: ["total_amount", "user_market_segment"],
  properties: {
    total_amount: {
      type: "number",
      title: "Total Amount",
      default: 0,
    },
    user_market_segment: {
      type: "number",
      title: "User Market Segment",
      default: 0,
    },
    remaining_assignment_time: {
      type: "number",
      title: "Remaining Assignment Time",
    },
    cell_assignment_time: {
      type: "number",
      title: "Cell Assignment Time",
    },
    is_bypassed_order: {
      type: "boolean",
      title: "Bypassed Order",
      default: false,
    },
  },
};

const OrderFormModal = (props) => {
  const classes = useStyles();
  const [formData, setFormData] = useState(null);
  const [formError, setFormError] = useState("");
  const { modalState, handleClose, finalConfig, orderSchema } = props;

  const handleSubmit = (evt) => {
    evt.preventDefault();
    props.getLevel(formData, finalConfig);
    handleClose();
  };

  const handleChange = (e) => {
    setFormData(e.formData);
  };

  return (
    <AnimatedDialog
      TransitionComponent={Transition}
      header={true}
      heading="Order Parameters"
      isVisible={!!modalState}
      permission={true}
      acceptLabel={"Submit"}
      rejectLabel={"Cancel"}
      handleAccept={handleSubmit}
      handleReject={handleClose}
      id="orderformmodal"
    >
      <div className="Order-Form">
        <Form
          children={true}
          formData={formData}
          onChange={handleChange}
          onSubmit={handleSubmit}
          schema={!isEmpty(orderSchema) ? orderSchema : formschema}
          omitExtraData={true}
        />
        {formError.length > 0 ? (
          <div className={`error-state ${classes.errorSpacing}`}>
            {"*" + formError}
          </div>
        ) : (
          ""
        )}
      </div>
    </AnimatedDialog>
  );
};

const mapStateToProps = (state) => {
  const { Level, GenSetting } = state;
  return {
    finalConfig: GenSetting.finalConfig,
    orderSchema: GenSetting.orderSchema,
    activeOrder: Level.order,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLevel: bindActionCreators(LevelActions.getLevel, dispatch),
    getFinalConfig: bindActionCreators(
      GenSettingActions.getFinalConfig,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderFormModal);
